import React, { useCallback, useEffect, useState } from "react";
import { useMounted } from "../../hooks/useMounted";
import {
  Button,
  Flex,
  Modal,
  Select,
  Table,
  Typography,
} from "antd";
import { useIntl } from "react-intl";
import IntlMessage from "../../components/IntlMessage";
import {
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

const RouteTrajetForm = (props) => {
  const { open, onClose, currentData } = props;
  const { isMounted } = useMounted();
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    onClose();
  };

  const columns = [
    {
      title: "",
      key: "button",
      width: 50,
      render: (_, record) => {
        return (
          <Flex gap={8}>
            <Button
              size="small"
              //   onClick={() => {
              //     onOpenSegmentModal(record, data.id, record?.id);
              //     setUpdateMaps(record?.route?.maps);
              //     // console.log("this is record: ", record);
              //   }}
              icon={<EditOutlined />}
            />
            <Button
              danger
              size="small"
              //   onClick={() => onDeleteSegment(record.id)}
              icon={<DeleteOutlined />}
            />
          </Flex>
        );
      },
    },
    {
      title: <IntlMessage id="global.trajet" />,
      key: "trajet",
      dataIndex: "trajet",
      width: 120,
      //   render: (_, record) => {
      //     return `${record?.start_stop?.title}`;
      //   },
    },
    {
      title: <IntlMessage id="global.depart" />,
      key: "depart",
      dataIndex: "depart",
      width: 40,
      //   render: (_, record) => {
      //     return `${record?.start_stop?.title}`;
      //   },
    },
    {
      title: <IntlMessage id="global.arrivee" />,
      key: "arrivee",
      dataIndex: "arrivee",
      width: 40,
      //   render: (_, record) => {
      //     return `${record?.end_stop?.title}`;
      //   },
    },
    {
      title: <IntlMessage id="global.code_trajet" />,
      key: "code_trajet",
      dataIndex: "code_trajet",
      width: 100,
      //   render: (_, record) => {
      //     return `${record?.end_stop?.title}`;
      //   },
    },
    {
      title: <IntlMessage id="global.description" />,
      key: "description",
      dataIndex: "description",
      width: 50,
      //   render: (_, record) => {
      //     // return <Input.TextArea rows={4} />;
      //   },
    },
    {
      title: <IntlMessage id="global.lieu_depart" />,
      key: "lieu_depart",
      dataIndex: "lieu_depart",
      width: 100,
      //   render: (_, record) => {
      //     // return <Input.TextArea rows={4} />;
      //   },
    },
    {
      title: <IntlMessage id="global.lieu_arrivee" />,
      key: "lieu_arrivee",
      dataIndex: "lieu_arrivee",
      width: 100,
      //   render: (_, record) => {
      //     // return <Input.TextArea rows={4} />;
      //   },
    },

    {
      title: <IntlMessage id="global.date" />,
      key: "date",
      dataIndex: "date",
      width: 100,
      //   render: (_, record) => {
      //     return record?.date
      //     ? dayjs(record.date).format("HH:mm")
      //     : null;
      //   },
    },
    {
      title: <IntlMessage id="global.heure" />,
      key: "heure",
      dataIndex: "heure",
      width: 50,
      render: (_, record) => {
        return record?.heure
          ? dayjs(record.heure, "HH:mm:ss").format("HH:mm")
          : null;
      },
    },
    {
      title: <IntlMessage id="global.heure_ramassage" />,
      key: "heure_ramassage",
      dataIndex: "heure_ramassage",
      width: 50,
      render: (_, record) => {
        return record?.heure_ramassage
          ? dayjs(record.heure_ramassage, "HH:mm:ss").format("HH:mm")
          : null;
      },
    },
    {
      title: <IntlMessage id="global.prix" />,
      key: "prix",
      dataIndex: "prix",
      width: 50,
      //   render: (_, record) => {
      //     return `${record?.from_price ?? ""}`;
      //   },
    },

    {
      title: <IntlMessage id="global.sous_trajet_id" />,
      key: "sous_trajet_id",
      dataIndex: "sous_trajet_id",
      width: 20,
      //   render: (_, record) => {
      //     return `${record?.id}`;
      //   },
    },
  ];

  return (
    <React.Fragment>
      <Modal
        title={<IntlMessage id="global.view" />}
        open={open}
        destroyOnClose={true}
        onCancel={handleCancel}
        width="90%"
        // onOk={handleSubmit}
        footer={[
          <Button
            key="submit"
            type="primary"
            htmlType="submit"
            loading={loading}
            onClick={handleCancel}
          >
            {<IntlMessage id="global.ok" />}
          </Button>,
        ]}
      >
        {/* <Form
          {...layout}
          form={form}
          initialValues={initialValues}
          labelAlign="left"
          onFinish={handleSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
        </Form> */}
        <Table
          tableLayout="auto"
          columns={columns}
          dataSource={currentData ?? []}
          rowKey="id"
          size="small"
          pagination={false}
        />
      </Modal>
    </React.Fragment>
  );
};

export default RouteTrajetForm;
